module.exports = __webpack_public_path__ + "00a8971a81e2488a43cd009a9a68ccce.png";